module.exports = function (app) {
    "use strict";
    app.controller('pages.clients', ["$state", "$scope", "sessionData", "$filter", "employerUtility", "brand", "services", "$cookies", '$window', "modal", function ($state, $scope, sessionData, $filter, employerUtility, brand, services, $cookies, $window, modal) {
        // $scope.sidebar = "testing...";
        // todo: remove

        $scope.sidebar = {
            breadCrumb: {
                primary: {
                    title: "Clients - Log in as an Employer"
                }
            }
        };

        console.log("Employer Info", $scope.employer);

        // todo: remove
        console.log("Session Data", sessionData.employerInfo);


        $scope.sidebar.links = [
            {
                heading: "Clients",
                label: "Login as Employer",
                state: "clients",
                description: "Need to see things from your client's perspective? log in as an employer to compare views."
            }
        ];

        $scope.client = null;
        $scope.clientObject = null;
        $scope.groups = [];
        $scope.ready = 'Loading List. This may take a while, please wait...';

        services.rbsmbl.clients().fetch().then(function (data) {

                                                   $scope.groups = data.data.payload.clients;
                                                   $scope.ready = true;

                                               },
                                               function () {
                                                   $scope.ready = 'List was unable to load. Please refresh or contact support.';
                                               });

        $scope.onItemSelected = function (selectedItem) {
            $scope.clientObject = this.clientObject;
        };

        $scope.updateClient = function (obj) {
            $scope.client = obj["clientName"];
        };

        $scope.showLogin = function () {
            if ($scope.clientObject) {
                return true;
            } else {
                return false;
            }
        };

        $scope.test = function (thing) {
            console.log(thing, $scope.groups, $scope.clientObject);
        };

        $scope.ssoToEmployer = function () {
            console.log($scope.clientObject);

            if ($scope.clientObject) {

                var clientId = $scope.clientObject.id,
                    agencyName = $scope.clientObject.name;

                //user story 488178
                //var ssoUrl = '/chmptl/chm/jsp/multiclientspa.do?mcClientID=' + clientId;

                //user story 816683

                var ssoUrl ='/employer/home';
                $cookies.put('multiClientID',clientId, { path: '/' });



                    window.location.href = ssoUrl;
            }
            else {
                modal.open({
                    template: "<article><section><h1>No Selection</h1><p>Please make a selection before trying to continue. Use the Search Bar or select an option from the dropdown. Thank you!</p></section></article>",
                    onClose: function () {

                    }
                });
            }

        };
    }]);

    return [
        {
            state: "clients",
            url: "/clients",
            postPassword: true,
            views: {
                'body@': {
                    template: bootstrap.templates['page-templates/hmhs/content-page.html'],
                    // template: bootstrap.templates['page-templates/category.html'],
                    // template: bootstrap.templates['page-templates/hmhs/content-page-side-bar.html'],
                    controller: "pages.clients"
                },
                "content@clients": {
                    template: require('./clients.html')
                }
            }
        }
    ];
};
